<div class="flex items-center flex-col w-full">
  <div
    class="flex flex-col items-center justify-center font-inter text-white bg-transparent w-full animate-slideUp w-[70%] self-center">
    <div class="p-10 md:p-10 w-full bg-transparent">
      <div class="flex flex-col items-center justify-center text-center">
        <div class="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 text-center">
          <!-- View Certificates -->
          <div class="transition-transform duration-300 hover:scale-105">
            <div
              class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl py-8 px-8 text-white transition duration-300 hover:border-yellow-400 hover:shadow-yellow-400/20 flex flex-col align-center">
              <div class="flex items-center mb-4">
                <i class="fas fa-shield-alt text-blue-400 text-2xl mr-3"></i>
                <div>
                  <h3 class="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">Server Certificates</h3>
                  <div class="flex items-center mt-1">
                    <p class="text-sm text-gray-300">
                      <span [ngClass]="{'text-green-400': dashboard?.certificates?.installedThisMonth > 0, 'text-red-400': dashboard?.certificates?.installedThisMonth < 0, 'text-gray-400': dashboard?.certificates?.installedThisMonth === 0}">
                        {{ dashboard?.certificates?.installedThisMonth > 0 ? ('+' + dashboard?.certificates?.installedThisMonth) : dashboard?.certificates?.installedThisMonth}}
                      </span>
                      <span class="text-gray-400 ml-1">Since Last Month</span>
                    </p>
                  </div>
                </div>
              </div>
              
              <div class="grid grid-cols-3 gap-4 mt-4 mb-6">
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <p class="text-3xl font-bold text-green-400">{{dashboard?.certificates?.active ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">Active</p>
                  <div class="w-8 h-1 bg-green-400 mx-auto mt-2 rounded-full"></div>
                </div>
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <p class="text-3xl font-bold text-yellow-400">{{dashboard?.certificates?.expired ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">Expired</p>
                  <div class="w-8 h-1 bg-yellow-400 mx-auto mt-2 rounded-full"></div>
                </div>
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <p class="text-3xl font-bold text-red-400">{{dashboard?.certificates?.noCerts ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">No SSL</p>
                  <div class="w-8 h-1 bg-red-400 mx-auto mt-2 rounded-full"></div>
                </div>
              </div>
              
              <button
                class="mt-2 self-center bg-blue-600 hover:bg-yellow-400 text-white hover:text-black font-semibold py-2.5 px-6 rounded-lg transition-all duration-300 w-fit flex items-center group shadow-lg shadow-blue-600/20 hover:shadow-yellow-400/30"
                (click)="goTo('/certificates')">
                <span>View Certificates</span>
                <i class="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
          <!-- Certificate Health Status -->
          <div class="transition-transform duration-300 hover:scale-105">
            <div
              class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl py-8 px-8 text-white transition duration-300 hover:border-yellow-400 hover:shadow-yellow-400/20 flex flex-col align-center">
              <div class="flex items-center mb-4">
                <i class="fas fa-heartbeat text-orange-400 text-2xl mr-3"></i>
                <div>
                  <h3 class="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-orange-200">Certificate Health</h3>
                  <div class="flex items-center mt-1">
                    <p class="text-sm text-gray-300">
                      <span [ngClass]="{'text-green-400': dashboard?.certificates?.installedThisMonth > 0, 'text-red-400': dashboard?.certificates?.installedThisMonth < 0, 'text-gray-400': dashboard?.certificates?.installedThisMonth === 0}">
                        {{ dashboard?.certificates?.installedThisMonth > 0 ? ('+' + dashboard?.certificates?.installedThisMonth) : dashboard?.certificates?.installedThisMonth}}
                      </span>
                      <span class="text-gray-400 ml-1">vs Last Month</span>
                    </p>
                  </div>
                </div>
              </div>
              
              <div class="grid grid-cols-3 gap-4 mt-4 mb-6">
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <!-- <div class="text-2xl mb-2">🟢</div> -->
                  <p class="text-3xl font-bold text-green-400">{{dashboard?.certificates?.active ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">Healthy</p>
                  <div class="w-8 h-1 bg-green-400 mx-auto mt-2 rounded-full"></div>
                </div>
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <!-- <div class="text-2xl mb-2">🟡</div> -->
                  <p class="text-3xl font-bold text-yellow-400">{{dashboard?.certificates?.expired ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">Expiring</p>
                  <div class="w-8 h-1 bg-yellow-400 mx-auto mt-2 rounded-full"></div>
                </div>
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <!-- <div class="text-2xl mb-2">🔴</div> -->
                  <p class="text-3xl font-bold text-red-400">{{dashboard?.certificates?.noCerts ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">At Risk</p>
                  <div class="w-8 h-1 bg-red-400 mx-auto mt-2 rounded-full"></div>
                </div>
              </div>
              
              <button
                class="mt-2 self-center bg-orange-600 hover:bg-yellow-400 text-white hover:text-black font-semibold py-2.5 px-6 rounded-lg transition-all duration-300 w-fit flex items-center group shadow-lg shadow-orange-600/20 hover:shadow-yellow-400/30"
                (click)="goTo('/certificates')">
                <span>View Details</span>
                <i class="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
          <!-- View Pen Tests -->
          <!-- <div class="transition-transform duration-300 hover:scale-105">
            <div
              class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl py-8 px-8 text-white transition duration-300 hover:border-yellow-400 hover:shadow-yellow-400/20 flex flex-col align-center h-full">
              <div class="flex items-center mb-4">
                <i class="fas fa-tasks text-purple-400 text-2xl mr-3"></i>
                <div>
                  <h3 class="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-purple-200">Pen Tests</h3>
                  <div class="flex items-center mt-1">
                    <p class="text-sm text-gray-300">
                      <span [ngClass]="{'text-green-400': dashboard?.userPens?.installedThisMonth > 0, 'text-red-400': dashboard?.userPens?.installedThisMonth < 0, 'text-gray-400': dashboard?.userPens?.installedThisMonth === 0}">
                        {{ dashboard?.userPens?.installedThisMonth > 0 ? ('+' + dashboard?.userPens?.installedThisMonth) : dashboard?.userPens?.installedThisMonth}}
                      </span>
                      <span class="text-gray-400 ml-1">Since Last Month</span>
                    </p>
                  </div>
                </div>
              </div>
              
              <div class="grid grid-cols-1 gap-4 mt-4 mb-6 flex-grow">
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <p class="text-3xl font-bold text-blue-400">{{dashboard?.userPens?.total ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">{{ dashboard?.userPens?.total == 1 ? 'Domain' : 'Domains' }}</p>
                  <div class="w-8 h-1 bg-blue-400 mx-auto mt-2 rounded-full"></div>
                </div>
              </div>
              
              <button
                class="mt-2 self-center bg-purple-600 hover:bg-yellow-400 text-white hover:text-black font-semibold py-2.5 px-6 rounded-lg transition-all duration-300 w-fit flex items-center group shadow-lg shadow-purple-600/20 hover:shadow-yellow-400/30"
                (click)="goTo('/pen')">
                <span>View Tests</span>
                <i class="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div> -->
          <!-- View Monitored Domains -->
          <div class="transition-transform duration-300 hover:scale-105">
            <div
              class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl py-8 px-8 text-white transition duration-300 hover:border-yellow-400 hover:shadow-yellow-400/20 flex flex-col align-center h-full">
              <div class="flex items-center mb-4">
                <i class="fas fa-satellite-dish text-teal-400 text-2xl mr-3"></i>
                <div>
                  <h3 class="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-teal-200">Monitored Domains</h3>
                  <div class="flex items-center mt-1">
                    <p class="text-sm text-gray-300">
                      <span [ngClass]="{'text-green-400': dashboard?.monitoredDomains?.startedThisMonth > 0, 'text-red-400': dashboard?.monitoredDomains?.startedThisMonth < 0, 'text-gray-400': dashboard?.monitoredDomains?.startedThisMonth === 0}">
                        {{ dashboard?.monitoredDomains?.startedThisMonth > 0 ? ('+' + dashboard?.monitoredDomains?.startedThisMonth) : dashboard?.monitoredDomains?.startedThisMonth}}
                      </span>
                      <span class="text-gray-400 ml-1">Started This Month</span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 mt-4 mb-6 flex-grow">
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <p class="text-3xl font-bold text-teal-400">{{dashboard?.monitoredDomains?.total ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">{{ dashboard?.monitoredDomains?.total == 1 ? 'Domain' : 'Domains' }}</p>
                  <div class="w-8 h-1 bg-teal-400 mx-auto mt-2 rounded-full"></div>
                </div>
                <div class="bg-[rgba(255,255,255,0.05)] rounded-lg p-4 text-center transition-all hover:bg-[rgba(255,255,255,0.1)]">
                  <p class="text-3xl font-bold text-cyan-400">{{dashboard?.monitoredDomains?.refreshedThisMonth ?? '0'}}</p>
                  <p class="text-xs uppercase tracking-wider mt-1 text-gray-300">Refreshed</p>
                  <div class="w-8 h-1 bg-cyan-400 mx-auto mt-2 rounded-full"></div>
                </div>
              </div>

              <button
                class="mt-2 self-center bg-teal-600 hover:bg-yellow-400 text-white hover:text-black font-semibold py-2.5 px-6 rounded-lg transition-all duration-300 w-fit flex items-center group shadow-lg shadow-teal-600/20 hover:shadow-yellow-400/30"
                (click)="goTo('/monitored-domains')">
                <span>View Domains</span>
                <i class="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bg-blue-500 grid grid-cols-1 md:grid-cols-2 gap-5 p-5 w-full">
      <div class="m-5 ">Hiew</div>
    </div> -->
    <div *ngIf="certificatesPieChart" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 p-8 w-full max-w-[80vw] mt-8">
      <div class="transition-all duration-300 hover:scale-[1.02]">
        <div class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl p-6 text-white">
          <div class="flex items-center mb-4">
            <i class="fas fa-chart-pie text-blue-400 text-2xl mr-3"></i>
            <h3 class="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">Certificate Status</h3>
          </div>
          <apx-chart 
            [series]="certificatesPieChart.series" 
            [chart]="certificatesPieChart.chart"
            [labels]="certificatesPieChart.labels" 
            [colors]="certificatesPieChart.colors"
            [dataLabels]="certificatesPieChart.dataLabels"
            [legend]="certificatesPieChart.legend"
            [stroke]="certificatesPieChart.stroke"
            [tooltip]="certificatesPieChart.tooltip"
            [plotOptions]="certificatesPieChart.plotOptions"
            [responsive]="certificatesPieChart.responsive">
          </apx-chart>
        </div>
      </div>
  
      <div *ngIf="certificatesBarChart" class="transition-all duration-300 hover:scale-[1.02]">
        <div class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl p-6 text-white">
          <div class="flex items-center mb-4">
            <i class="fas fa-chart-area text-blue-400 text-2xl mr-3"></i>
            <h3 class="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">Certificate Installation</h3>
          </div>
          <apx-chart 
            [series]="certificatesBarChart.series" 
            [chart]="certificatesBarChart.chart"
            [xaxis]="certificatesBarChart.xaxis" 
            [yaxis]="certificatesBarChart.yaxis"
            [dataLabels]="certificatesBarChart.dataLabels" 
            [colors]="certificatesBarChart.colors"
            [fill]="certificatesBarChart.fill"
            [stroke]="certificatesBarChart.stroke"
            [grid]="certificatesBarChart.grid"
            [tooltip]="certificatesBarChart.tooltip"
            [markers]="certificatesBarChart.markers">
          </apx-chart>
        </div>
      </div>
  
      <div *ngIf="userPensPieChart" class="transition-all duration-300 hover:scale-[1.02]">
        <div class="border border-gray-700 bg-gradient-to-br from-[rgba(29,37,85,0.90)] to-[rgba(5,5,12,0.95)] rounded-xl shadow-xl p-6 text-white">
          <div class="flex items-center mb-4">
            <i class="fas fa-chart-line text-purple-400 text-2xl mr-3"></i>
            <h3 class="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-purple-200">Pen Tests Overview</h3>
          </div>
          <apx-chart 
            [series]="userPensPieChart.series" 
            [chart]="userPensPieChart.chart" 
            [xaxis]="userPensPieChart.xaxis"
            [yaxis]="userPensPieChart.yaxis"
            [dataLabels]="userPensPieChart.dataLabels"
            [colors]="userPensPieChart.colors"
            [fill]="userPensPieChart.fill"
            [stroke]="userPensPieChart.stroke"
            [markers]="userPensPieChart.markers"
            [grid]="userPensPieChart.grid"
            [tooltip]="userPensPieChart.tooltip"
            [annotations]="userPensPieChart.annotations">
          </apx-chart>
        </div>
      </div>
    </div>
  
  </div>

</div>